<template>  
    <div ref="mapContainer" class="amap-container"></div>  
  </template>  
    
  <script>  
  export default {  
    name: 'AmapComponent',  
    data() {  
      return {  
        map: null,  
        marker: null,  
        infoWindow: null  
      };  
    },  
    // mounted() {  
    //   this.initMap();  
    // },  

    mounted() {  
    if (window.AMap) {  
      this.initMap();  
    } else {  
      // 如果 AMap 还没有定义，可以设置一个监听器来等待它加载  
      let intervalId = setInterval(() => {  
        if (window.AMap) {  
          clearInterval(intervalId);  
          this.initMap();  
        }  
      }, 100);  
    }  
  }, 

    methods: {  
      initMap() { 
        if (typeof window.AMap !== 'undefined') {
        // 创建地图实例  
        this.map = new window.AMap.Map(this.$refs.mapContainer, {  
          zoom: 13,  
          center: [117.20372, 39.116569],  
          resizeEnable: true,
          mapStyle: "amap://styles/whitesmoke", //设置地图的显示样式  
        });  
    


        // 创建点覆盖物  
        this.marker = new window.AMap.Marker({  
          position: new window.AMap.LngLat(117.20372, 39.116569),  
          icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',  
          offset: new window.AMap.Pixel(-13, -30)  
        });  
        this.map.add(this.marker);  
    
        // 创建信息窗体  
        this.infoWindow = new window.AMap.InfoWindow({  
          isCustom: true,  
          content: '<div class="cus_info_window">华夏好瑞（天津）科技有限公司</div>',  
          offset: new window.AMap.Pixel(16, -45)  
        });  
    
        // 绑定 click 事件  
        this.marker.on('click', this.onMarkerClick);  
    }else {  
        // AMap 未定义，可以设置延迟或重试逻辑  
        console.error('AMap is not defined. Please ensure the AMap SDK is loaded correctly.');  
      }  
      },  

      onMarkerClick(e) {  
        this.infoWindow.open(this.map, e.target.getPosition());  
      }
    }  
  };  
  </script>  
    
  <style scoped>  
  .amap-container {  
    height: 100%;  
    width: 100%;  
  }  
    
  .amap-icon img,  
  .amap-marker-content img {  
    width: 25px;  
    height: 34px;  
  }  
    
  .cus_info_window {  
    background-color: #fff;  
    padding: 10px;  
  }  
  </style>